module.exports = __webpack_public_path__ + "img/30-XL6.4048a6f.png";